module.exports = __webpack_public_path__ + "static/14medical-49efe842c0bf92b060a073233a7d498e.png";